const frontTruncate = (text, term, preTermChars = 40) => {
  const termIndex = text.toLowerCase().indexOf(term.toLowerCase());
  if (termIndex === -1) {
    return text;
  }

  const preTermString = text.substring(0, termIndex);
  const termToEndString = text.substring(termIndex);

  const processedPreTermString =
    preTermString.length > preTermChars
      ? `...${preTermString.substring(preTermString.length - preTermChars)}`
      : preTermString;

  return processedPreTermString + termToEndString;
};

export default frontTruncate;
